var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('center',[_c('br'),_vm._v(" "),_c('h1',[_vm._v("Logged Out")]),_c('br'),_vm._v("\n  Thanks for using the system."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n  To log back in, "),_c('a',{on:{"click":_vm.login}},[_vm._v("click here")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }